export default __webpack_public_path__ + "static/media/rack9.9d0a884f.jpg";